import React from "react";
import { Box, Grid, IconButton, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import MenuItems from "./MenuItems";

export default function HiddenContent({ setOpen }) {
  const menuItems = [
    {
      name: "ویرا",
      path: "/",
      description: "بازگشت به صفحه اصلی و مشاهده بخش‌های مهم سایت",
      size: { xs: 12 },
    },
    {
      name: "پروژه‌ها",
      path: "/projects",
      description: "نمایش نمونه‌کارها و پروژه‌های انجام شده",
      size: { xs: 12, md: 6 },
    },
    {
      name: "مقالات",
      path: "/blogs",
      description: "مشاهده آخرین اخبار ویرا",
      size: { xs: 12, md: 6 },
    },
    {
      name: "درباره ما",
      path: "/about",
      description: "آشنایی با ما مهارت‌ها و مسیر حرفه‌ای",
      size: { xs: 12, md: 6 },
    },
    {
      name: " خدمات ",
      path: "/services",
      description: "خدمات ما برای بهبود کسب و کار شما",
      size: { xs: 12, md: 6 },
    },
    {
      name: " همکاری ",
      path: "/employment-form",
      description: "استخدام و شروع همکاری با ما",
      size: { xs: 12 },
    },
  ];

  const items = menuItems?.map((item, index) => (
    <Grid sx={{ justifyContent: "center" }} size={item?.size}>
      <MenuItems index={index} item={item} key={item?.name} setOpen={setOpen} />
    </Grid>
  ));

  return (
    <Box
      sx={{
        position: "relative",
        height: "100%",
        width: "100%",
        overflow: "hidden",
        color: "#fff",
        background: `
          radial-gradient(circle at top right, rgba(64, 12, 155, 0.15), transparent 35%),
          radial-gradient(circle at bottom left, rgba(59,130,246,0.12), transparent 30%),
          linear-gradient(135deg, #050505 0%, #0f0f1868 100%)
        `,
      }}
    >
      {/* content */}
      <Stack
        justifyContent="center"
        alignItems="center"
        spacing={3}
        sx={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          px: 2,
          py: 6,
        }}
      >
        {/* close button */}
        <IconButton
          size="large"
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            top: 24,
            right: 24,

            background: "rgba(255,255,255,0.06)",
            backdropFilter: "blur(12px)",

            border: "1px solid rgba(255,255,255,0.08)",
            color: "#fff",

            transition: "0.35s ease",

            "&:hover": {
              transform: "rotate(90deg) scale(1.08)",
              background: "rgba(255,255,255,0.1)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* menu items */}
        <Grid
          container
          spacing={3}
          sx={{ maxHeight: "100%", width: "100%", justifyContent: "center" , maxWidth:"850px"}}
        >
          {items}
        </Grid>
      </Stack>
    </Box>
  );
}
